export const FuelKey = {
  DEVICE_TYPE: 'deviceType',
  NO_UNITS: 'numberOfUnit',
  FUEL_USED: 'fuelUsed',
  QUANTITY_TF: 'quantity',
  COST_TF: 'fuelcost',
  STATUS: 'status',
  YEAR: 'year',
  FACILITY: 'facility',
  COMMENT: 'comment'
};
export const FuelLabel = {
  DEVICE_TYPE: 'Device Type',
  NO_UNITS: 'No. of Units',
  FUEL_USED: 'Fuel Used',
  QUANTITY_TF: 'Quantity',
  COST_TF: 'Fuel Cost',
  STATUS_COMMENTS: 'Status & Comments',
  FULL_INFO: 'Full Info',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
export const FuelTooltip = {
  FUEL_USED:
    'Enter the fuel used for the total number of selected devices/units.',
  QUANTITY: 'Enter the total fuel quantity for all selected devices/units.',
  FUEL_COST: 'Enter the total fuel cost for all selected devices/units.'
};
